import React from 'react'
import SideNav from '../../components/student/Sidenav'
import StudentDashboard from '../../components/student/Dashboard'
import Header from '../../components/Header'
function Dashboard() {
  return (
  <>
        <Header/>
        <SideNav/>
        <StudentDashboard/>
    </>
  )
}

export default Dashboard
